import { render } from "./PartyJoinModal.vue?vue&type=template&id=1c874ae9&scoped=true&ts=true"
import script from "./PartyJoinModal.vue?vue&type=script&lang=ts"
export * from "./PartyJoinModal.vue?vue&type=script&lang=ts"

import "./PartyJoinModal.vue?vue&type=style&index=0&id=1c874ae9&scoped=true&lang=css"

import exportComponent from "/home/bese/Documents/partybeast/party-beast-prototype/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c874ae9"]])

export default __exports__